module.exports = __webpack_public_path__ + "static/media/tennis.99ae32bb.svg";